import * as React from "react";
import { defaults } from "lodash/fp";
import { getFilterReference } from "./FilterDefs";
/**
 */
export class Filter extends React.Component {
    constructor(props) {
        super(props);
    }
    /*
    componentWillReceiveProps(nextProps) {
      const { filters } = this.props;
      const { filters: nextFilters, setFilter } = nextProps;
      if (filters !== nextFilters) {
        nextFilters.forEach(function(nextFilterName) {
          setFilter({ filterName: nextFilterName, ...nextProps });
        });
      }
    }
      //*/
    render() {
        const { props } = this;
        const { childTag, childOnlyProps, firstChildStyleProps, parentFill } = props;
        const { className, color, fill, strokeWidth } = firstChildStyleProps;
        let filters = props.filters || [];
        const filterCount = filters.length;
        const filtersAreUsed = filterCount > 0;
        const descendantStyle = {
            color: "inherit",
            fill: "inherit",
            fillOpacity: "inherit",
            stroke: "inherit",
            strokeWidth: "inherit"
        };
        const ChildTag = childTag;
        if (!filtersAreUsed) {
            return React.createElement(ChildTag, Object.assign({}, defaults(childOnlyProps, firstChildStyleProps)));
        }
        else {
            return filters.reduce(function (acc, filterName, i) {
                const filterReference = getFilterReference({
                    color,
                    filterName,
                    fill,
                    strokeWidth,
                    parentFill
                });
                let props = {};
                if (i + 1 === filterCount) {
                    // this is the final (outermost) g element with a filter
                    props = firstChildStyleProps;
                }
                else {
                    props.style = descendantStyle;
                }
                return (React.createElement("g", Object.assign({ filter: filterReference }, props), acc));
            }, React.createElement(ChildTag, Object.assign({ style: descendantStyle }, childOnlyProps)));
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmlsdGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvRmlsdGVyL0ZpbHRlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxLQUFLLEtBQUssTUFBTSxPQUFPLENBQUM7QUFFL0IsT0FBTyxFQUFFLFFBQVEsRUFBRSxNQUFNLFdBQVcsQ0FBQztBQUVyQyxPQUFPLEVBQUUsa0JBQWtCLEVBQUUsTUFBTSxjQUFjLENBQUM7QUFFbEQ7R0FDRztBQUNILE1BQU0sT0FBTyxNQUFPLFNBQVEsS0FBSyxDQUFDLFNBQW1CO0lBQ25ELFlBQVksS0FBa0I7UUFDNUIsS0FBSyxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBQ2YsQ0FBQztJQUVEOzs7Ozs7Ozs7O1VBVUc7SUFFSCxNQUFNO1FBQ0osTUFBTSxFQUFFLEtBQUssRUFBRSxHQUFHLElBQUksQ0FBQztRQUV2QixNQUFNLEVBQ0osUUFBUSxFQUNSLGNBQWMsRUFDZCxvQkFBb0IsRUFDcEIsVUFBVSxFQUNYLEdBQUcsS0FBSyxDQUFDO1FBRVYsTUFBTSxFQUFFLFNBQVMsRUFBRSxLQUFLLEVBQUUsSUFBSSxFQUFFLFdBQVcsRUFBRSxHQUFHLG9CQUFvQixDQUFDO1FBRXJFLElBQUksT0FBTyxHQUFHLEtBQUssQ0FBQyxPQUFPLElBQUksRUFBRSxDQUFDO1FBRWxDLE1BQU0sV0FBVyxHQUFHLE9BQU8sQ0FBQyxNQUFNLENBQUM7UUFDbkMsTUFBTSxjQUFjLEdBQUcsV0FBVyxHQUFHLENBQUMsQ0FBQztRQUN2QyxNQUFNLGVBQWUsR0FBRztZQUN0QixLQUFLLEVBQUUsU0FBUztZQUNoQixJQUFJLEVBQUUsU0FBUztZQUNmLFdBQVcsRUFBRSxTQUFTO1lBQ3RCLE1BQU0sRUFBRSxTQUFTO1lBQ2pCLFdBQVcsRUFBRSxTQUFTO1NBQ3ZCLENBQUM7UUFFRixNQUFNLFFBQVEsR0FBRyxRQUFRLENBQUM7UUFDMUIsSUFBSSxDQUFDLGNBQWMsRUFBRTtZQUNuQixPQUFPLG9CQUFDLFFBQVEsb0JBQUssUUFBUSxDQUFDLGNBQWMsRUFBRSxvQkFBb0IsQ0FBQyxFQUFJLENBQUM7U0FDekU7YUFBTTtZQUNMLE9BQU8sT0FBTyxDQUFDLE1BQU0sQ0FBQyxVQUFTLEdBQUcsRUFBRSxVQUFVLEVBQUUsQ0FBQztnQkFDL0MsTUFBTSxlQUFlLEdBQUcsa0JBQWtCLENBQUM7b0JBQ3pDLEtBQUs7b0JBQ0wsVUFBVTtvQkFDVixJQUFJO29CQUNKLFdBQVc7b0JBQ1gsVUFBVTtpQkFDWCxDQUFDLENBQUM7Z0JBQ0gsSUFBSSxLQUFLLEdBQXdCLEVBQUUsQ0FBQztnQkFDcEMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxLQUFLLFdBQVcsRUFBRTtvQkFDekIsd0RBQXdEO29CQUN4RCxLQUFLLEdBQUcsb0JBQW9CLENBQUM7aUJBQzlCO3FCQUFNO29CQUNMLEtBQUssQ0FBQyxLQUFLLEdBQUcsZUFBZSxDQUFDO2lCQUMvQjtnQkFFRCxPQUFPLENBQ0wseUNBQUcsTUFBTSxFQUFFLGVBQWUsSUFBTSxLQUFLLEdBQ2xDLEdBQUcsQ0FDRixDQUNMLENBQUM7WUFDSixDQUFDLEVBQUUsb0JBQUMsUUFBUSxrQkFBQyxLQUFLLEVBQUUsZUFBZSxJQUFNLGNBQWMsRUFBSSxDQUFDLENBQUM7U0FDOUQ7SUFDSCxDQUFDO0NBQ0YifQ==